import React from 'react';
import { StyledRadioGroup } from './index.styled';

interface AppRadioGroupProps {
  size?: 'small' | 'large';
  options?: Array<{ label: string; value: any; disabled?: boolean }>;
  value?: any;
  onChange?: (e: any) => void;
  disabled?: boolean;
  className?: string;
  defaultValue?: string;
  [key: string]: any;
}

const AppRadioGroup: React.FC<AppRadioGroupProps> = ({
  size = 'large',
  className,
  onChange,
  ...props
}) => {
  const handleChange = (e: any) => {
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <StyledRadioGroup
      {...props}
      onChange={handleChange}
      className={className ?? ''}
      size={size}
    />
  );
};

export default AppRadioGroup;
